// /* eslint-disable react-hooks/exhaustive-deps */
// import {FC, useContext, useState, useEffect, useMemo} from 'react'
// import {useQuery} from 'react-query'
// import {
//   createResponseContext,
//   initialQueryResponse,
//   initialQueryState,
//   PaginationState,
//   QUERIES,
//   stringifyRequestQuery,
//   WithChildren,
// } from '../../../../../../_metronic/helpers'
// import {getUsers} from './_requests'
// import {User} from './_models'
// import {useQueryRequest} from './QueryRequestProvider'

// const QueryResponseContext = createResponseContext<User>(initialQueryResponse)
// const QueryResponseProvider: FC<WithChildren> = ({children}) => {
//   const {state} = useQueryRequest()
//   const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
//   const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])
//   useEffect(() => {
//     if (query !== updatedQuery) {
//       setQuery(updatedQuery)
//     }
//   }, [updatedQuery])
//   const {
//     isFetching,
//     refetch,
//     data: response,
//   } = useQuery(
//     `${QUERIES.USERS_LIST}-${query}`,
//     () => {
//       return getUsers(query, state.initialApi)
//       // return getUsers(query)
//     },
//     {
//       cacheTime: 0,
//       keepPreviousData: true,
//       refetchOnWindowFocus: false,
//       enabled: state.enabled,
//     }
//   )

//   return (
//     <QueryResponseContext.Provider value={{isLoading: isFetching, refetch, response, query}}>
//       {children}
//     </QueryResponseContext.Provider>
//   )
// }

// const useQueryResponse = () => useContext(QueryResponseContext)

// const useQueryResponseData = () => {
//   const {response} = useQueryResponse()
//   if (!response) {
//     return []
//   }
//   return response?.data || []
//   // return mockedData.data
// }

// /* const useQueryResponsePagination = () => {
//   const defaultPaginationState: PaginationState = {
//     links: [],
//     ...initialQueryState,
//   }

//   const {response} = useQueryResponse()
//   if (!response || !response.payload || !response.payload.pagination) {
//     return defaultPaginationState
//   }

//   return response.payload.pagination
// } */
// const useQueryResponsePagination = () => {
//   const defaultPaginationState: PaginationState = {
//     links: [],
//     ...initialQueryState,
//   }

//   const {response} = useQueryResponse()
//   // console.log({response})
//   if (!response || !response.meta) {
//     return defaultPaginationState
//   }
//   return response.meta
// }

// const useQueryResponseLoading = (): boolean => {
//   const {isLoading} = useQueryResponse()
//   return isLoading
// }

// export {
//   QueryResponseProvider,
//   useQueryResponse,
//   useQueryResponseData,
//   useQueryResponsePagination,
//   useQueryResponseLoading,
// }





/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useContext, useState, useEffect, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  initialQueryState,
  PaginationState,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { getUsers } from './_requests'
import { User } from './_models'
import { useQueryRequest } from './QueryRequestProvider'

const QueryResponseContext = createResponseContext<User>(initialQueryResponse)
const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { state } = useQueryRequest()
  const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
  const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])
  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])
  const {
    isFetching,
    refetch,
    data: response,
  } = useQuery(
    `${QUERIES.USERS_LIST}-${query}`,
    () => {
      return getUsers(query, state.initialApi, (state as any).franchiseId)
      // return getUsers(query)
    },
    {
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: state.enabled,
    }
  )

  return (
    <QueryResponseContext.Provider value={{ isLoading: isFetching, refetch, response, query }}>
      {children}
    </QueryResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryResponseContext)

const useQueryResponseData = () => {
  const { response } = useQueryResponse()
  if (!response) {
    return []
  }
  return response?.data || []
  // return mockedData.data
}

/* const useQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  }

  const {response} = useQueryResponse()
  if (!response || !response.payload || !response.payload.pagination) {
    return defaultPaginationState
  }

  return response.payload.pagination
} */
const useQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  }

  const { response } = useQueryResponse()
  // console.log({response})
  if (!response || !response.meta) {
    return defaultPaginationState
  }
  return response.meta
}

const useQueryResponseLoading = (): boolean => {
  const { isLoading } = useQueryResponse()
  return isLoading
}

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponsePagination,
  useQueryResponseLoading,
}
